// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-mSX","actions":"styles_actions__3eYIS","error":"styles_error__2Pupz","message":"styles_message__3Fa3q"};